import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

const PartnerDashboardPage = () => {
    const [partnerUser, setPartnerUser] = useState(null);
    const [darkMode, setDarkMode] = useState(localStorage.getItem('darkMode') === 'true');
    const [isActive, setIsActive] = useState(false); // Sidebar toggle
    const [currentView, setCurrentView] = useState('overview'); // 'overview', 'transactions'
    const [stats, setStats] = useState({ total: 0, success: 0, failed: 0, volume: 0 });
    const [logs, setLogs] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        type: '',
        status: ''
    });
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'PayzoPay - Partner Paneli';
    }, []);

    useEffect(() => {
        const userStr = localStorage.getItem('partner_user');
        if (!userStr) {
            const isPartnerDomain = window.location.hostname.startsWith('partner');
            navigate(isPartnerDomain ? '/login' : '/partner/login');
            return;
        }
        setPartnerUser(JSON.parse(userStr));
        fetchPartnerData();
        const interval = setInterval(fetchPartnerData, 10000);
        return () => clearInterval(interval);
    }, [navigate]);

    const fetchPartnerData = async () => {
        try {
            const token = localStorage.getItem('partner_token');
            const res = await api.getPartnerStats({ Authorization: token });
            setStats(res.data.stats);
            setLogs(res.data.logs);
        } catch (error) {
            console.error("Veri çekilemedi", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTransactions = async () => {
        try {
            const token = localStorage.getItem('partner_token');
            const res = await api.getPartnerTransactions(filters, { Authorization: token });
            setTransactions(res.data);
        } catch (error) {
            console.error("İşlemler çekilemedi", error);
        }
    };

    useEffect(() => {
        if (currentView === 'transactions') {
            fetchTransactions();
        }
    }, [currentView, filters]);

    const toggleTheme = () => {
        const newMode = !darkMode;
        setDarkMode(newMode);
        localStorage.setItem('darkMode', newMode);
    };

    const toggleSidebar = () => {
        setIsActive(!isActive);
    };

    const handleLogout = () => {
        localStorage.removeItem('partner_token');
        localStorage.removeItem('partner_user');
        const isPartnerDomain = window.location.hostname.startsWith('partner');
        navigate(isPartnerDomain ? '/login' : '/partner/login');
    };

    if (!partnerUser) return null;

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    // App.js ile aynı tema stilleri
    const themeStyles = {
        '--bg-color': darkMode ? '#121212' : '#f4f7f6',
        '--card-bg': darkMode ? '#1e1e1e' : '#ffffff',
        '--text-color': darkMode ? '#e0e0e0' : '#333333',
        '--border-color': darkMode ? '#444444' : '#eeeeee',
        '--input-border': darkMode ? '#555' : '#ccc',
        '--input-bg': darkMode ? '#2d2d2d' : '#ffffff',
        '--table-header-bg': darkMode ? '#2d2d2d' : '#f8f9fa',
        '--table-row-even': darkMode ? '#2d2d2d' : '#f8f9fa',
        '--shadow': darkMode ? '0 4px 20px rgba(0,0,0,0.4)' : '0 4px 20px rgba(0,0,0,0.08)',
        minHeight: '100vh',
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        transition: 'background-color 0.3s, color 0.3s'
    };

    const cardStyle = (borderColor) => ({
        backgroundColor: 'var(--card-bg)', borderRadius: '8px', padding: '20px',
        borderLeft: `5px solid ${borderColor}`, flex: 1, minWidth: '200px',
        boxShadow: 'var(--shadow)', color: 'var(--text-color)'
    });

    const inputStyle = { padding: '8px', borderRadius: '4px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)', width: '100%', boxSizing: 'border-box' };

    return (
        <div className="wrapper" style={themeStyles}>
            {/* --- SIDEBAR --- */}
            <nav id="sidebar" className={isActive ? 'active' : ''}>
                <div className="sidebar-header">
                    <h3>PayzoPay</h3>
                    <div style={{ fontSize: '0.8em', color: '#aaa', marginTop: '5px' }}>Partner Paneli</div>
                </div>

                <ul className="components">
                    <p className="sidebar-heading">MENÜ</p>

                    <li className={currentView === 'overview' ? 'active' : ''}>
                        <a href="#" onClick={(e) => { e.preventDefault(); setCurrentView('overview'); }}>
                            <i className="fas fa-home"></i>
                            <span>Genel Bakış</span>
                        </a>
                    </li>

                    <li className={currentView === 'transactions' ? 'active' : ''}>
                        <a href="#" onClick={(e) => { e.preventDefault(); setCurrentView('transactions'); }}>
                            <i className="fas fa-exchange-alt"></i>
                            <span>İşlemlerim</span>
                        </a>
                    </li>

                    <div className="sidebar-divider"></div>
                    <p className="sidebar-heading">AYARLAR</p>

                    <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                            <i className="fas fa-key"></i>
                            <span>API Anahtarları</span>
                        </a>
                    </li>

                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                            <i className="fas fa-sign-out-alt"></i>
                            <span>Çıkış Yap</span>
                        </a>
                    </li>
                </ul>

                <div className="sidebar-bottom">
                    <button type="button" className="btn-toggle" onClick={toggleSidebar}>
                        <i className="fas fa-chevron-left"></i>
                    </button>
                </div>
            </nav>

            {/* --- İÇERİK ALANI --- */}
            <div id="content">
                <nav className="navbar" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', background: 'transparent', boxShadow: 'none', borderBottom: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button type="button" id="sidebarCollapse" className="btn btn-info" onClick={toggleSidebar} style={{ marginRight: '15px', background: 'none', border: 'none', color: 'var(--text-color)', fontSize: '1.2em', cursor: 'pointer' }}>
                            <i className="fas fa-bars"></i>
                        </button>
                        <h4 style={{ margin: 0 }}>{partnerUser.companyName || partnerUser.email}</h4>
                    </div>

                    <button
                        onClick={toggleTheme}
                        title={darkMode ? 'Açık Tema' : 'Koyu Tema'}
                        style={{
                            width: '40px', height: '40px', borderRadius: '50%', border: 'none',
                            backgroundColor: darkMode ? '#f1c40f' : '#343a40', color: darkMode ? '#333' : '#fff',
                            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                        }}
                    >
                        <i className={`fas ${darkMode ? 'fa-sun' : 'fa-moon'}`} style={{ fontSize: '1.2em' }}></i>
                    </button>
                </nav>

                <div style={{ padding: '20px' }}>
                    {currentView === 'overview' ? (
                        <>
                            <h2 style={{ marginBottom: '20px', color: 'var(--text-color)' }}>Genel Bakış</h2>

                            {/* İstatistikler */}
                            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginBottom: '30px' }}>
                                <div style={cardStyle('#007bff')}>
                                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', opacity: 0.8 }}>Toplam İşlem</h5>
                                    <h3 style={{ margin: 0, fontSize: '1.8em' }}>{stats.total}</h3>
                                </div>
                                <div style={cardStyle('#28a745')}>
                                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#28a745' }}>Başarılı</h5>
                                    <h3 style={{ margin: 0, fontSize: '1.8em', color: '#28a745' }}>{stats.success}</h3>
                                </div>
                                <div style={cardStyle('#dc3545')}>
                                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#dc3545' }}>Hatalı</h5>
                                    <h3 style={{ margin: 0, fontSize: '1.8em', color: '#dc3545' }}>{stats.failed}</h3>
                                </div>
                                <div style={cardStyle('#ffc107')}>
                                    <h5 style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: '#ffc107' }}>Toplam Hacim</h5>
                                    <h3 style={{ margin: 0, fontSize: '1.8em', color: '#ffc107' }}>{stats.volume.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL</h3>
                                </div>
                            </div>

                            {/* Son İşlemler Tablosu */}
                            <h3 style={{ color: 'var(--text-color)', marginBottom: '15px' }}>Son İşlemler</h3>
                            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
                                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', color: 'var(--text-color)' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: 'var(--table-header-bg)', textAlign: 'left' }}>
                                            <th style={{ padding: '15px' }}>Tarih</th>
                                            <th>Tip</th>
                                            <th>Tutar</th>
                                            <th>Durum</th>
                                            <th>Banka</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logs.length === 0 ? (
                                            <tr><td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>Henüz işlem bulunmuyor.</td></tr>
                                        ) : (
                                            logs.map(log => (
                                                <tr key={log._id} style={{ borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--table-row-even)' }}>
                                                    <td style={{ padding: '12px 15px' }}>{new Date(log.createdAt).toLocaleString()}</td>
                                                    <td>{log.requestType === 'deposit' ? 'Yatırım' : 'Çekim'}</td>
                                                    <td style={{ fontWeight: 'bold' }}>{Number(log.requestedAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL</td>
                                                    <td>
                                                        <span style={{
                                                            padding: '4px 8px', borderRadius: '4px', fontSize: '0.85em',
                                                            backgroundColor: log.success ? '#28a745' : '#dc3545', color: '#fff'
                                                        }}>
                                                            {log.success ? 'Başarılı' : 'Hata'}
                                                        </span>
                                                    </td>
                                                    <td>{log.requestedBank || '-'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    ) : (
                        <>
                            <h2 style={{ marginBottom: '20px', color: 'var(--text-color)' }}>İşlem Geçmişi</h2>

                            {/* Filtreler */}
                            <div style={{ backgroundColor: 'var(--card-bg)', padding: '20px', borderRadius: '8px', marginBottom: '20px', boxShadow: 'var(--shadow)' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9em', color: 'var(--text-color)' }}>Başlangıç Tarihi</label>
                                        <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} style={inputStyle} />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9em', color: 'var(--text-color)' }}>Bitiş Tarihi</label>
                                        <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} style={inputStyle} />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9em', color: 'var(--text-color)' }}>İşlem Tipi</label>
                                        <select name="type" value={filters.type} onChange={handleFilterChange} style={inputStyle}>
                                            <option value="">Tümü</option>
                                            <option value="deposit">Yatırım</option>
                                            <option value="withdrawal">Çekim</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9em', color: 'var(--text-color)' }}>Durum</label>
                                        <select name="status" value={filters.status} onChange={handleFilterChange} style={inputStyle}>
                                            <option value="">Tümü</option>
                                            <option value="success">Başarılı</option>
                                            <option value="failed">Hatalı</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Tablo */}
                            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
                                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', color: 'var(--text-color)' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: 'var(--table-header-bg)', textAlign: 'left' }}>
                                            <th style={{ padding: '15px' }}>Tarih</th>
                                            <th>Tip</th>
                                            <th>Tutar</th>
                                            <th>Durum</th>
                                            <th>Banka</th>
                                            <th>İsim</th>
                                            <th>Hata</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transactions.length === 0 ? (
                                            <tr><td colSpan="7" style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>Kayıt bulunamadı.</td></tr>
                                        ) : (
                                            transactions.map(log => (
                                                <tr key={log._id} style={{ borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--table-row-even)' }}>
                                                    <td style={{ padding: '12px 15px' }}>{new Date(log.createdAt).toLocaleString()}</td>
                                                    <td>{log.requestType === 'deposit' ? 'Yatırım' : 'Çekim'}</td>
                                                    <td style={{ fontWeight: 'bold' }}>{Number(log.requestedAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL</td>
                                                    <td>
                                                        <span style={{
                                                            padding: '4px 8px', borderRadius: '4px', fontSize: '0.85em',
                                                            backgroundColor: log.success ? '#28a745' : '#dc3545', color: '#fff'
                                                        }}>
                                                            {log.success ? 'Başarılı' : 'Hata'}
                                                        </span>
                                                    </td>
                                                    <td>{log.requestedBank || '-'}</td>
                                                    <td>{log.fullname || '-'}</td>
                                                    <td style={{ color: '#dc3545', fontSize: '0.9em' }}>{log.errorCode || '-'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PartnerDashboardPage;